export default __webpack_public_path__ + "static/media/FECTC.22e6f2cf.png";